import React, { FC } from 'react';
import Image from 'next/image';
import styled from 'styled-components';
import { StoredImageDTO } from 'src/common/models/image';

const ImageContainer = styled.div`
  align-items: center;
  display: flex;
  width: 4.25rem;
  height: 4.25rem;
  position: relative;
  margin-right: 1.875rem;

  img {
    object-fit: contain;
    object-position: center;
  }
`;

export const CourseBundleListItemImage: FC<{ image?: StoredImageDTO }> = ({ image }) =>
  !image ? null : (
    <ImageContainer>
      <Image src={image.url} width={image.width} height={image.height} layout="fill" />
    </ImageContainer>
  );
